<template>
    <div class="col-6 floating-labels reader-form">
        <div class="row m-r-20">
<!--          Тип запису-->
            <div class="col-6 dataTables_length">
                    <label for="type_record_id">ТИП ЗАПИСУ</label>
                    <v-select v-model="inputs.type_record"
                              id="type_record_id"
                              :options="type_record"
                              label="name"
                              class="form-control static"
                              placeholder=" "
                              @search="getDatalist('type_record',$event)"
                              @input="getDatalist('type_record','')"
                              :filterable="false"
                              @search:focus="getDatalist('type_record', '')"
                              ref="type_record"
                              :loading="selectLoading['type_record']"
                    >
                        <template #no-options="{ search, searching, loading }">
                            Категорії не знайдено
                        </template>
                      <template #spinner="{ loading }">
                        <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                          The .vs__spinner class will hide the text for me.
                        </div>
                      </template>
                    </v-select>
                    <input v-if="inputs.type_record && inputs.type_record.id" type="text" name="additional[type_record]" v-model="inputs.type_record.id" hidden>
            </div>
<!--          //Тип запису-->

          <!--          ОСНОВНА РУБРИКА-->
          <div class="col-6 dataTables_length">
            <label for="rubric">ОСНОВНА РУБРИКА</label>
            <v-select v-model="inputs.rubric"
                      id="rubric"
                      :options="rubric"
                      label="name"
                      class="form-control static"
                      placeholder=" "
                      @search="getDatalist('rubric',$event)"
                      :filterable="false"
                      @search:focus="getDatalist('rubric', '')"
                      ref="rubric"
                      :loading="selectLoading['rubric']"
            >
              <template #no-options="{ search, searching, loading }">
                Категорії не знайдено
              </template>
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                  The .vs__spinner class will hide the text for me.
                </div>
              </template>
            </v-select>
            <input v-if="inputs.rubric && inputs.rubric.id" type="text" name="additional[rubric]" v-model="inputs.rubric.id" hidden>
          </div>
          <!--          //ОСНОВНА РУБРИКА-->

        </div>
        <div class="row m-r-20">
<!--          isbn-->
          <div class="col-6 dataTables_length">
            <label for="isbn">ISBN</label>
            <v-select v-model="inputs.isbn"
                      id="isbn"
                      :options="isbn"
                      label="name"
                      class="form-control static"
                      placeholder=" "
                      @search="getDatalist('isbn',$event)"
                      @input="getDatalist('isbn','')"
                      :filterable="false"
                      @search:focus="getDatalist('isbn', '')"
                      ref="isbn"
                      :reduce="name=>name.name"
                      taggable
                      :loading="selectLoading['isbn']"
            >
              <template #no-options="{ search, searching, loading }">
                Категорії не знайдено
              </template>
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                  The .vs__spinner class will hide the text for me.
                </div>
              </template>
            </v-select>
            <input v-if="inputs.isbn" type="text" name="additional[isbn]" v-model="inputs.isbn" hidden>
          </div>
<!--          //isbn-->

<!--          автор-->
          <div class="col-6 dataTables_length">
            <label for="author">АВТОР</label>
            <v-select v-model="inputs.author"
                      id="author"
                      :options="author"
                      label="name"
                      class="form-control static"
                      placeholder=" "
                      @search="getDatalist('author',$event)"
                      :filterable="false"
                      @search:focus="getDatalist('author', '')"
                      ref="author"
                      :reduce="name=>name.name"
                      taggable
                      :loading="selectLoading['author']"
            >
              <template #no-options="{ search, searching, loading }">
                Категорії не знайдено
              </template>
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                  The .vs__spinner class will hide the text for me.
                </div>
              </template>
            </v-select>
            <input v-if="inputs.author" type="text" name="additional[author]" v-model="inputs.author" hidden>
          </div>
<!--          //автор-->

        </div>

        <div class="row m-r-20">
          <!--          ВИДАВНИЦТВО-->
          <div class="col-6 dataTables_length">
            <label for="publication">ВИДАВНИЦТВО</label>
            <v-select v-model="inputs.publication"
                      id="publication"
                      :options="publication"
                      label="name"
                      class="form-control static"
                      placeholder=" "
                      @search="getDatalist('publication',$event)"
                      :filterable="false"
                      @search:focus="getDatalist('publication', '')"
                      :reduce="name=>name.name"
                      taggable
                      :loading="selectLoading['publication']"
            >
              <template #no-options="{ search, searching, loading }">
                Категорії не знайдено
              </template>
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                  The .vs__spinner class will hide the text for me.
                </div>
              </template>
            </v-select>
            <input v-if="inputs.publication" type="text" name="additional[publication]" v-model="inputs.publication" hidden>
          </div>
          <!--          //ВИДАВНИЦТВО-->
          <!--          МОВА ВИДАННЯ-->
          <div class="col-6 dataTables_length">
            <label for="languages">МОВА ВИДАННЯ</label>
            <v-select v-model="inputs.languages"
                      id="languages"
                      :options="languages"
                      label="name"
                      class="form-control static"
                      placeholder=" "
                      @search="getDatalist('languages',$event)"
                      :filterable="false"
                      @search:focus="getDatalist('languages', '')"
                      :loading="selectLoading['languages']"
            >
              <template #no-options="{ search, searching, loading }">
                Категорії не знайдено
              </template>
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                  The .vs__spinner class will hide the text for me.
                </div>
              </template>
            </v-select>
            <input v-if="inputs.languages && inputs.languages.id" type="text" name="additional[languages]" v-model="inputs.languages.id" hidden>
          </div>
          <!--          //МОВА ВИДАННЯ-->
        </div>
        <div class="row m-r-20">
          <!--          АУДИТОРІЯ-->
          <div class="col-6 dataTables_length">
            <label for="audience">АУДИТОРІЯ</label>
            <v-select v-model="inputs.audience"
                      id="audience"
                      :options="audience"
                      label="name"
                      class="form-control static"
                      placeholder=" "
                      @search="getDatalist('audience',$event)"
                      :filterable="false"
                      @search:focus="getDatalist('audience', '')"
                      ref="audience"
                      :loading="selectLoading['audience']"
            >
              <template #no-options="{ search, searching, loading }">
                Категорії не знайдено
              </template>
              <template #spinner="{ loading }">
                <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                  The .vs__spinner class will hide the text for me.
                </div>
              </template>
            </v-select>
            <input v-if="inputs.audience && inputs.audience.id" type="text" name="additional[audience]" v-model="inputs.audience.id" hidden>
          </div>
          <!--          АУДИТОРІЯ-->
<!--          ФОРМАТ-->
            <div class="col-6 dataTables_length">
              <label for="book_format">ФОРМАТ</label>
              <v-select v-model="inputs.book_format"
                        id="book_format"
                        :options="book_format"
                        label="name"
                        class="form-control static"
                        placeholder=" "
                        @search="getDatalist('book_format',$event)"
                        :filterable="false"
                        @search:focus="getDatalist('book_format', '')"
                        :loading="selectLoading['book_format']"
              >
                <template #no-options="{ search, searching, loading }">
                  Категорії не знайдено
                </template>
                <template #spinner="{ loading }">
                  <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                    The .vs__spinner class will hide the text for me.
                  </div>
                </template>
              </v-select>
              <input v-if="inputs.book_format && inputs.book_format.id" type="text" name="additional[book_format]" v-model="inputs.book_format.id" hidden>
            </div>
<!--          ФОРМАТ-->
        </div>
        <div class="row m-r-20">
<!--          ДІАПАЗОН ДАТ ПУБЛІКАЦІЇ-->
            <div class="col-6 dataTables_filter dataTables_length" >
                    <label style="background-image: unset;margin: 0">ДІАПАЗОН ДАТ ПУБЛІКАЦІЇ</label>
                    <input type="text" name="additional[year]" v-model="inputs.year" class="year">
                <div>Наприклад: 1999-2001. Можна також використовувати „-1987“ щоб знайти усе опубліковане у та до 1987 року або „2008-“ для пошуку опублікованого у та після 2008 року.</div>
            </div>
<!--          //ДІАПАЗОН ДАТ ПУБЛІКАЦІЇ-->
          <!--              РОЗТАШУВАННЯ ТА НАЯВНІСТЬ-->
          <div class="col-6 dataTables_length">
                <label for="location">РОЗТАШУВАННЯ ТА НАЯВНІСТЬ</label>
                <v-select id="location"
                          v-model="inputs.libraries"
                          :options="libraries"
                          label="title"
                          class="form-control static"
                          placeholder=" "
                          :filterable="false"
                          @search:focus="getDatalist('libraries', '')"
                          :loading="selectLoading['libraries']"
                >
                    <template #no-options="{ search, searching, loading }">
                        Категорії не знайдено
                    </template>
                    <template #option="{title, id}">
                        <span v-html="title"></span>
                    </template>
                    <template #selected-option="{title, id}">
                        <span v-html="title"></span>
                    </template>
                  <template #spinner="{ loading }">
                    <div v-if="loading" style="border-left-color: rgba(88,151,251,0.71)" class="vs__spinner">
                      The .vs__spinner class will hide the text for me.
                    </div>
                  </template>
                </v-select>
                <input v-if="inputs.libraries && inputs.libraries.id" type="text" name="additional[libraries]" v-model="inputs.libraries.id" hidden>

                <input type="checkbox" id="available" v-model="inputs.available" :checked="inputs.available ? true : false" name="additional[available]" class="search-checkbox custom-checkbox">
                <label for="available" style="margin: -15px"><span>Лише примірники доступні зараз для видачі</span></label>
            </div>
          <!--              //РОЗТАШУВАННЯ ТА НАЯВНІСТЬ-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "SearchForm",
        props:['additional'],
        data(){
            return {
                isbn:[],
                author:[],
                libraries:[],
                type_record:[],
                audience:[],
                rubric:[],
                book_format:[],
                languages:[],
                publication:[],
                selectLoading:[],
                inputs:{
                    libraries:null,
                    author:null,
                    isbn:null,
                    type_record: null,
                    audience:null,
                    rubric:null,
                    book_format:null,
                    languages:null,
                    year:null,
                    available:null
                },
            }
        },

        mounted() {
          if(this.additional != 'null'){
            let additional = JSON.parse(this.additional);
            Object.keys(additional).forEach(el => {
              if(el != 'year' && el != 'publication' && el != 'author' && el != 'isbn' && el != 'available'){
                this.getFieldId(el,additional[el]);
              }else{
                this.inputs[el] = additional[el];
              }
            });
          }
        },
        methods:{
          getFieldId(field,id){
            axios.get('/library/settings/'+id+'?type='+field).then(response => {
              this.inputs[field] = response.data.data;
            });
          },
          getDatalist(field, title) {
            this.selectLoading[field] = true;
            axios.get('/library/settings?field=' + field + '&name=' + title).then(response => {
              this[field] = response.data.data;
              this.selectLoading[field] = false;
            });
          }
        }
    }
</script>

<style scoped>
.form-control >>> .vs__dropdown-toggle,
.form-control >>> .vs__dropdown-menu{
  font-size: 13px;
  border: none;
}
.form-control >>> .vs__actions{
  padding:0;
  margin-right: -5px;
}
.form-control >>> .vs__search,
.form-control >>> .vs__search::placeholder,
.form-control >>> .vs__selected{
  font-size: 13px;
  color: #414141;
  white-space: nowrap;
  padding: 0;
  margin: 10px 0 0 0;
}
.form-control >>> .vs__selected-options{
  padding: 0;
}
.form-control >>>.vs__selected-options {
  width: 90%;
  overflow: hidden;
  padding: 0;
}
.form-control >>>.vs__selected {
  width: 99%;
  overflow: hidden;
}
.static >>> .mdi{
  color:#5C6F7C;
}

    .form-control{
        min-height: 40px;
        color:#414141;
    }
    input{
        /*color: #9E9E9E;*/
        color:#414141;
        font-size: 13px;
    }
    .reader-form label {
        top: -1.5em !important;
        font-family: var(--font-family-serif);
        font-size: 8px;
        font-style: normal;
        color: #414141 !important;
        font-weight: 500;
    }
    .dataTables_length{
      margin: 0;
      padding-top: 1px;
    }

    .vs__dropdown-option span {
        line-height: 1.42857143;
        display: block;
        padding: 3px 20px;
        clear: both;
        color: #333;
        white-space: nowrap;
    }

    .vs__dropdown-option--highlight span {
        background: #5897fb;
        color: #fff;
    }

    .vs__selected span {
        display: flex;
        align-items: center;
        background-color: #f0f0f0;
        border: 1px solid rgba(60, 60, 60, 0.26);
        border-radius: 4px;
        color: #333;
        line-height: 1.4;
        /*margin: 4px 2px 0px 2px;*/
        padding: 0 0.25em;
        z-index: 0;
    }

    .form-control .vs__selected span {
        width: 99%;
        overflow: hidden;
        font-size: 13px;
        color: #414141;
        white-space: nowrap;
        padding: 0;
        /*margin: 10px 0 0 0;*/
    }

    .vs--single .vs__selected span {
        background-color: transparent;
        border-color: transparent;
    }

</style>